import { useEffect, useState } from 'react';

const PHRASES = [
  'Businesses lose opportunities when customers cannot get answers quickly.',
  'Answer customer inquiries instantly, even after hours.',
  'Coordinate your appointments and follow-ups without the back-and-forth.',
  'Missed calls and delayed follow‑ups quietly cost revenue.',
  'Confirm bookings and send reminders without extra staff effort.',
  'Your website should feel as professional as your business.',
  'Customers should never struggle to reach your team.',
];

const TYPE_SPEED = 45;
const ERASE_SPEED = 22;
const PAUSE_AFTER_TYPE = 2800;
const PAUSE_AFTER_ERASE = 400;

export function useTyped() {
  const [displayed, setDisplayed] = useState('');
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [isErasing, setIsErasing] = useState(false);

  useEffect(() => {
    const phrase = PHRASES[phraseIndex];

    if (!isErasing) {
      if (displayed.length < phrase.length) {
        const t = setTimeout(() => {
          setDisplayed(phrase.slice(0, displayed.length + 1));
        }, TYPE_SPEED);
        return () => clearTimeout(t);
      } else {
        const t = setTimeout(() => setIsErasing(true), PAUSE_AFTER_TYPE);
        return () => clearTimeout(t);
      }
    } else {
      if (displayed.length > 0) {
        const t = setTimeout(() => {
          setDisplayed(displayed.slice(0, -1));
        }, ERASE_SPEED);
        return () => clearTimeout(t);
      } else {
        const t = setTimeout(() => {
          setIsErasing(false);
          setPhraseIndex((i) => (i + 1) % PHRASES.length);
        }, PAUSE_AFTER_ERASE);
        return () => clearTimeout(t);
      }
    }
  }, [displayed, isErasing, phraseIndex]);

  return displayed;
}
